import React from 'react';
import { FiUserPlus, FiMessageSquare, FiCheck, FiUsers } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const SocialLearning = () => {
  return (
    <section className="py-24 px-4 bg-zinc-900 border-y border-zinc-800 overflow-hidden relative">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-blue-500/5 blur-[100px]"></div>
      
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <div className="inline-flex items-center gap-2 bg-blue-500/10 border border-blue-500/50 text-blue-500 px-4 py-1 rounded-full mb-6 text-xs font-bold uppercase tracking-widest">
            <SafeIcon icon={FiUsers} /> Comunidad Activa
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-white mb-6 uppercase leading-none">
            Make Friends & <br/>
            <span className="text-blue-500">Practice Together</span>
          </h2>
          <p className="text-xl text-gray-400 mb-10 leading-relaxed">
            Adding friends is useful because you can message them even if they are offline. Build your own study group!
          </p>

          <div className="space-y-8">
            <div className="flex gap-6">
              <div className="w-12 h-12 bg-zinc-800 rounded-2xl flex items-center justify-center text-blue-500 shrink-0 font-black text-xl">1</div>
              <div>
                <h4 className="text-white font-bold mb-2 uppercase tracking-widest text-sm">How to Add a Friend</h4>
                <p className="text-gray-500 text-sm">Haz clic en el avatar de cualquier compañero en las salas y selecciona "Add Friend".</p>
              </div>
            </div>
            <div className="flex gap-6">
              <div className="w-12 h-12 bg-zinc-800 rounded-2xl flex items-center justify-center text-blue-500 shrink-0 font-black text-xl">2</div>
              <div>
                <h4 className="text-white font-bold mb-2 uppercase tracking-widest text-sm">How to Chat with Friends</h4>
                <p className="text-gray-500 text-sm">Abre tu lista de amigos desde la flecha del chat y envía mensajes instantáneos.</p>
              </div>
            </div>
          </div>

          <a href="https://app.onlineclassesenglish.com" className="inline-flex items-center gap-3 bg-blue-600 text-white px-10 py-5 rounded-2xl font-black text-lg uppercase tracking-widest hover:bg-blue-500 transition-all mt-12 shadow-2xl shadow-blue-900/40">
            Start Making Friends Now
          </a>
        </div>

        <div className="relative">
          <div className="bg-black/50 border border-zinc-700 p-4 rounded-[2.5rem] shadow-2xl">
            <div className="bg-zinc-900 rounded-[2rem] p-6 space-y-4">
              <div className="flex items-center justify-between border-b border-zinc-800 pb-4">
                <span className="text-white font-bold uppercase text-xs">Friends Online (12)</span>
                <SafeIcon icon={FiMessageSquare} className="text-blue-500" />
              </div>
              {[
                { name: "Carlos M.", status: "Online", level: "Lvl 12" },
                { name: "Maria L.", status: "In Class", level: "Lvl 45" },
                { name: "Patricia R.", status: "Online", level: "Lvl 23" }
              ].map((friend, i) => (
                <div key={i} className="flex items-center justify-between p-3 bg-black/40 rounded-2xl border border-zinc-800 hover:border-blue-500/50 transition-all">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-full border-2 border-zinc-800"></div>
                    <div>
                      <div className="text-white font-bold text-sm">{friend.name}</div>
                      <div className="text-[10px] text-green-500 font-bold uppercase">{friend.status}</div>
                    </div>
                  </div>
                  <div className="text-[10px] font-black text-gray-500 uppercase">{friend.level}</div>
                </div>
              ))}
              <div className="pt-4">
                <button className="w-full bg-zinc-800 text-gray-400 py-3 rounded-xl font-bold text-xs uppercase hover:text-white transition-colors border border-zinc-700">
                  Ver Todos los Amigos
                </button>
              </div>
            </div>
          </div>
          {/* Floating UI Element */}
          <div className="absolute -bottom-10 -left-10 bg-green-600 text-white p-6 rounded-3xl shadow-2xl hidden md:block">
            <div className="flex items-center gap-3">
              <SafeIcon icon={FiUserPlus} className="text-2xl" />
              <div>
                <div className="font-black uppercase tracking-tighter text-lg leading-none">+250</div>
                <div className="text-[10px] font-bold uppercase opacity-80">Nuevos Amigos Hoy</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialLearning;